import { Activityeditor } from '@linktivity/gds-neo';
import config from '../config';

const pricingApi = new Activityeditor.PricingApi(config);

export default pricingApi;
